import Vue from 'vue';

import { selectColumn } from '@/shared/handsontable/mixins/featureSelectableRows';
import { tableSettingsColumn } from '@/shared/handsontable/mixins/featureTablesettingsColumn';

import { combinedNameExclCrop, companyId, crop, customer, fieldNumber, name, size, status, variety } from './columns';

export const tableFields = [
  {
    ...selectColumn,
    hiddenInPageSettings: true,
    lockedVisibility: true,
    lockedPosition: true,
  },
  {
    ...companyId,
    lockedVisibility: true,
    lockedPosition: true,
    requiredFeatures: (store) => store.state.auth.currentCompanies.length > 1,
  },
  {
    ...combinedNameExclCrop,
    header: {
      title: () => Vue.i18n.translate('Kunde - Feldstück - Feld'),
      description: () => Vue.i18n.translate('Kunde - Feldstück - Feld'),
    },
    width: 145,
    lockedPosition: true,
    sortOrder: 'asc',
  },
  {
    ...size,
    readOnly: true,
    width: 70,
  },
  {
    ...crop,
    lockedPosition: false,
    readOnly: true,
    width: 85,
  },
  {
    ...variety,
    readOnly: true,
    width: 85,
  },
  {
    ...fieldNumber,
    hiddenPerDefault: true,
    readOnly: true,
  },
  {
    ...customer,
    hiddenPerDefault: true,
    readOnly: true,
  },
  {
    ...name,
    hiddenPerDefault: true,
    className: '',
    width: 145,
    readOnly: true,
  },

  {
    ...status,
    hiddenPerDefault: true,
    readOnly: true,
  },

  tableSettingsColumn,
];

export default {
  international: tableFields,
};
